import { lazy, Suspense } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import type { WysiwygProps } from "./WysiwygEditor";

// CKEditor is heavy (~1.3 MB gzip); loading it lazily keeps it out of the initial bundle.
const WysiwygEditorLazy = lazy(() =>
  import("./WysiwygEditor").then((module) => ({ default: module.WysiwygEditor }))
);

export function Wysiwyg(props: WysiwygProps) {
  return (
    <Suspense
      fallback={
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={24} />
        </Box>
      }
    >
      <WysiwygEditorLazy {...props} />
    </Suspense>
  );
}
